import React from 'react';
import { useDropzone } from 'react-dropzone';
import cloudUpload from 'assets/img/icons/cloud-upload.svg';
import { getSize } from 'helpers/utils';
import { FaTrash } from 'react-icons/fa';
import PropTypes from 'prop-types';

const BookingUploadAttachment = ({files, setFiles}) => {

  const { getRootProps, getInputProps } = useDropzone({
    accept: 'image/*, .doc, .docx, .xls, .xlsx, .pdf',
    onDrop: acceptedFiles => {
      setFiles(
        acceptedFiles.map(file =>
          Object.assign(file, {
            preview: URL.createObjectURL(file)
          })
        )
      );
    }
  });

  const handleRemove = path => {
    setFiles(files.filter(file => file.path !== path));
  };

  return (
    <div>
      <div
        {...getRootProps({
          className:
            'tw-border-2 tw-border-dashed tw-border-slate-300 tw-rounded tw-py-6 tw-bg-slate-50 tw-cursor-pointer hover:tw-border-blue-400 tw-transition-colors'
        })}
      >
        <input {...getInputProps()} />
        <div className="tw-flex tw-justify-center tw-items-center">
          <img src={cloudUpload} alt="" width={25} className="tw-mr-2" />
          <p className="tw-text-base tw-mb-0 tw-text-slate-700">Drop your files here</p>
        </div>
      </div>

      <div className="tw-mt-3">
        {files && files.map(file => (
          <div
            className="tw-flex tw-items-center tw-py-1 tw-border-b tw-border-solid tw-border-slate-200"
            key={file.path}
          >
            <div className="tw-flex tw-justify-between tw-items-center tw-ml-3 tw-flex-1">
              <div>
                <h6>{file.path}</h6>
                <div className="tw-flex tw-relative tw-items-center">
                  <p className="tw-mb-0 tw-text-xs tw-text-slate-400 tw-leading-none">
                    <strong>
                      {getSize(file.size)}
                    </strong>
                  </p>
                </div>
              </div>
            </div>

            <FaTrash onClick={() => handleRemove(file.path)} style={{cursor: "pointer"}} />
          </div>
        ))}
      </div>
    </div>
  );
};

BookingUploadAttachment.propTypes = {
  files: PropTypes.array.isRequired,
  setFiles: PropTypes.func.isRequired
}

export default BookingUploadAttachment;